import React from "react"
import Counter from "./Counter"
import Subscribe from "./Subscribe"
import { useUserInfo } from "../hooks/useUserInfo"
import FallingPills from "./FallingPills"
import Share from "./Share"
import MembershipUsers from "./MembershipUsers"
import ServiceIntro from "./ServiceIntro"
// import FAQ from "./FAQ"

function Body() {
  const { loggedIn } = useUserInfo()
  return (
    <div>
      <Counter />
      <FallingPills />
      <ServiceIntro />
      <MembershipUsers />
      <Share />
      {!loggedIn && <Subscribe />}
      {/* <FAQ /> */}
    </div>
  )
}

export default Body
